import { useLocation, useNavigate } from 'react-router';
import { useClientContext } from 'client/context';
import { updateModal } from 'ducks/modals/slices';
import { updateSettings } from 'ducks/settings/slices';
import { useAppDispatch } from 'store/hooks';
import { mergeQuery } from 'utils/queries';
import { uuidv4 } from 'utils/uuid';

import { EMPTY_PROMISE } from '../constants';

import { useConfirmModalProps } from './types';

export const useConfirmModal = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const { handleError } = useClientContext();

  return async ({ title, message, onConfirm = EMPTY_PROMISE }: useConfirmModalProps) => {
    dispatch(
      updateModal({
        key: 'confirm',
        data: {
          title,
          message,
          is_open: true,
          onConfirm: async () => {
            try {
              dispatch(updateSettings({ loading: true }));
              await onConfirm();
              navigate(`${pathname}${mergeQuery(search, { update: uuidv4() })}`);
            } catch (err) {
              handleError(err);
            }
          },
        },
      })
    );
  };
};
